import { render } from "./JoinOur.vue?vue&type=template&id=64d34b2e"
import script from "./JoinOur.vue?vue&type=script&lang=js"
export * from "./JoinOur.vue?vue&type=script&lang=js"

import "./JoinOur.vue?vue&type=style&index=0&id=64d34b2e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__